// @module Tavano.TTCoAForm.CoAForm
define('Tavano.TTFormCoa.CoaForm.View'
,	[
	'tavano_ttformcoa_coaform.tpl'
	
	,	'Tavano.TTFormCoa.CoaForm.Model'

		, 'Backbone'
		, 'Backbone.FormView'
		, 'Backbone.CompositeView'
		, 'CoaForm.Confirmation.View'
		, 'SC.Configuration'
		, 'GlobalViews.Message.View'
	]
	, function (
		tavano_ttcoaform_coaform_tpl

		, CoAFormSS2Model
		, Backbone
		, BackboneFormView
		, BackboneCompositeView
		, coaConfirmationView
		, Configuration
		, GlobalViewsMessageView
	) {
		'use strict';

		// @class Tavano.TTCoAForm.CoAForm.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavano_ttcoaform_coaform_tpl

			, initialize: function (options) {

				BackboneCompositeView.add(this);
				this.model = new CoAFormSS2Model();
				var self = this;

				//Get Components
				this.application = options.application;
				var environment = this.application.getComponent('Environment');

				//Get ReCaptcha Configuration
				this.siteKey = environment.getConfig('TTCaptchaKeysV3.siteKey');
				this.javascriptAPIUrl = environment.getConfig('TTCaptchaKeysV3.javascriptAPIUrl');
				this.enableLogs = environment.getConfig('TTCaptchaKeysV3.enableLogs');
				this.enableRecaptcha = this.siteKey && this.javascriptAPIUrl;

				//Load ReCaptcha
				window.grecaptcha = _.bind(this.render, this);
				this.loadRecaptchaScript(this.siteKey, this.javascriptAPIUrl);
				this.captchaPromise = jQuery.getScript(this.javascriptAPIUrl);

				BackboneFormView.add(this);
				this.model.on('save', jQuery.proxy(this, 'manageResponse'));
			}

			, events: {
				'submit form': 'validateForm'
			}

			,	manageResponse : function showSuccess(model) {
				
				var targetEl = '#grecaptcha-error-message';

				if (model.get("status") == 500){

					//Show Recaptcha Error Message
					var messageView = new GlobalViewsMessageView({
						errorCode: 'ERR_RECAPTCHA_INVALID',
						message: model.get("message"),
						type: 'error',
						closable: true
					});
					
					this.$(targetEl).show();
					this.$(targetEl).html(messageView.render().$el);

				} else {

					//Show Success Message
					this.$(targetEl).hide();
					this.showSuccess();
				}
			}

			, bindings: {
				'[name="ordernumber"]': 'ordernumber'
				, '[name="partnumber"]': 'partnumber'
				, '[name="email"]': 'email'
				, '[name="lotnumber"]': 'lotnumber'
			}

			, showSuccess: function showSuccess() {
				var layout = this.application.getLayout();
				var coaFormConfirmationView = new coaConfirmationView({});
				layout.showInModal(coaFormConfirmationView,{});
				this.render();
			}

			, render: function () {
				
				Backbone.View.prototype.render.apply(this, arguments);

			}
			
			,	submitForm: function (e) {
				
				BackboneFormView.saveForm.apply(this, arguments);
			
			}
			
			,	validateForm: function(e){

				var self = this;

				if(this.enableRecaptcha && this.captchaPromise.state() === 'resolved'){

					try {

						e.preventDefault();

						var gRecaptcha = grecaptcha || window.grecaptcha
						,   promise = jQuery.Deferred()
						,   grecaptchaRes = {};

						gRecaptcha.ready(function()
						{
							gRecaptcha.execute(self.siteKey, {action:'coaForm'})
							.then(function(token)
							{
			
								if(self.enableLogs) {
									console.log("gRecaptcha Token", token);
								}

								//Set Token
								self.model.set('token', token);

								//Submit Form
								self.submitForm(e);
								
							})
						});
					} catch (err) {
						console.log('Error rendering recaptcha: ', err);
					}
				} else {
					
					//Submit Form
					this.submitForm(e);

				}

			},

			loadRecaptchaScript: function loadRecaptchaScript(siteKey, javascriptAPIUrl){
				
				var script = document.createElement('script');

				script.type = "text/javascript";
				script.src = javascriptAPIUrl + siteKey;
				script.defer = true;

				jQuery('head').append(script);
				
			}

			, childViews: {

			}

			//@method getContext @return Tavano.TTCoAForm.CoAForm.View.Context
			, getContext: function getContext() {
				var manufacturers = Configuration.get('TTCoAConfig.options');
				return {
					manufacturers: manufacturers || []
				};
			}
		});
	});
